// extracted by mini-css-extract-plugin
export var buttonConnect = "ButtonConnect_buttonConnect__iBBFW";
export var blockIcon = "ButtonConnect_blockIcon__SSm8+";
export var rotate = "ButtonConnect_rotate__WDkOX";
export var dotty = "ButtonConnect_dotty__tFvOF";